<div class="flex flex-column h-full">
    <div class="flex flex-column align-items-center justify-content-center pt-3 gap-2" *ngIf="!isMobileView">
        <div class="logo cursor-pointer" (click)="navigateToLanding()">
            <img src="assets/imgs/logo.svg" alt="APCRDA">
        </div>
        <button  *ngIf="!isAccessDenied" text="true" pButton (click)="toggleSidebar()" class="menu-button" pTooltip="Menu" severity="contrast">
            <i-tabler [name]="isCollapsed ? 'menu-3' : 'menu-2'"></i-tabler> <span>Menu</span>
        </button>
    </div>

    <ng-container *ngIf="isMobileView && !isAccessDenied">
        <div class="flex flex-column align-items-center justify-content-center pt-3 gap-2">
            <div class="logo cursor-pointer" (click)="navigateToLanding()">
                <img src="assets/imgs/logo.svg" alt="APCRDA" class="h-10">
            </div>
        </div>
        <div class="flex p-3 gap-3 align-items-center" *ngIf="isMobileView">
            <span class="flex-1 m-0 text-2xl text-700 font-medium">Menu</span>
            <p-button (onClick)="closeSidebar()" text="true" severity="secondary" icon="pi pi-times">
            </p-button>
        </div>
    </ng-container>


    <div class="overflow-y-auto">
        <p-panelmenu [model]="items" styleClass="sidemenu" *ngIf="hasResourcesAccess && !isAccessDenied">
            <ng-template #item let-item>
                <a pRipple class="menu-item relative" [routerLink]="item.link" routerLinkActive="active"
                    [pTooltip]="item.label" (click)="closeSidebar()">
                    <i-tabler [name]="item.icon" class="menu-item-icon ti-2xl"></i-tabler>
                    <span class="menu-item-label hide-on-collapse">
                        {{ item.label }}
                    </span>
                    <span class="ml-auto inline-flex gap-2 ">
                        <p-badge *ngIf="item.badge" [value]="item.badge" severity="danger"
                            styleClass="menu-badge absolute top-0 right-0" />
                        <i-tabler *ngIf="item.items?.length" [name]="item.expanded ? 'chevron-up' : 'chevron-down'"
                            class="ti-xl menu-item-expand-icon hide-on-collapse"></i-tabler>
                    </span>

                </a>
            </ng-template>
        </p-panelmenu>
    </div>
    <!-- <div class="mt-auto flex flex-column align-items-center justify-content-center py-3" (click)="logOut()">
        <button pButton text="true" class="menu-button" pTooltip="Logout" severity="secondary">
            <i-tabler name="logout"></i-tabler>
            <span>Logout</span>
        </button>
    </div> -->

    <div class="mt-auto flex flex-column align-items-start p-3">
        <p-menu #menu [model]="userMenuItems" [popup]="true"></p-menu>

        <p-button (click)="menu.toggle($event)" styleClass="p-0 border-circle overflow-hidden"
            [style]="{ width: '40px', height: '40px' }" [text]="true">
            <p-avatar image="assets/imgs/user.png" shape="circle" size="normal" ariaLabel="Profile Pic"
                styleClass="bg-gray-400 text-white"></p-avatar>
        </p-button>
    </div>

</div>